import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import SignupAccount from '@/models/v5/signup_account';
import template from '@/../templates/login-forgot-password.hbs';
    
    var globalCh = Radio.channel('global');

    /**
     * Show an alert confirming the address a forgotten password email
     * was sent to and redirect to the login page
     */
    function alert_request_success_and_redirect_to_login(email) {
        var msg = "Instructions sent to " + email;
        Radio.request(
            'alerts',
            'showAlert', {
                message: msg,
                messageType: 'success'
            }
        );
        globalCh.request('login');
    }
    function alert_request_error(resp) {
        var message;
        if (!(resp && resp.responseJSON && resp.responseJSON.errors))
            message = 'An unknown error occurred.';
        else {
            message = resp.responseJSON.errors.map(function(e) {
                return e.detail;
            }).join('; ');
        }
        Radio.request(
            'alerts',
            'showAlert', {
                message: message,
                messageType: 'danger'
            }
        );
    }
    export default Marionette.View.extend({
        template: Handlebars.compile(template),

        events: {
            'submit form': 'handleSubmit'
        },

        handleSubmit : function(event) {
            event.preventDefault();
            event.stopPropagation();
            var data = this.validate();
            if (!data) {
                Radio.request(
                    'alerts',
                    'showAlert', {
                        message: "Check your email address and try again",
                        messageType: 'danger'
                    }
                );
                return false;
            }
            var signup_account = new SignupAccount(data);

            signup_account.request_password_reset()
                .done(
                    alert_request_success_and_redirect_to_login
                        .bind(this, data.email)
                )
                .fail(alert_request_error)
            ;

            return false;
        },

        validate : function() {
            var email = this.$('input[name="email"]').val();
            if (email && email.length) return ({ email: email });
            return false;
        }

    });

